import { FaSpinner } from "react-icons/fa";

const Loading = () => {
    return (
        <div >
            <FaSpinner className="spinner" />
        </div>
    );
};

export default Loading;